import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  inject,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DropdownToggleDirective } from 'src/app/shared/directives/dropdown-toggle.directive';
import { ErrorHandleService } from 'src/app/shared/services/error-handle/error-handle.service';
import { environment } from 'src/environments/environment';
import { FiltroBuscaService } from '../service/filtro-busca-service/filtro-busca.service';

@Component({
  selector: 'app-filtro-fase-obra',
  standalone: true,
  imports: [CommonModule, FormsModule, DropdownToggleDirective],
  templateUrl: './filtro-fase-obra.component.html',
  styleUrl: './filtro-fase-obra.component.scss',
})
export class FiltroFaseObraComponent {
  BASE_IMG_URL: string = environment.BASE_IMG_URL;
  filtroFaseDaObra: Array<any> = [];

  @Output() fasesObraChange = new EventEmitter<any[]>();
  @Input() fasesSelecionadas: number[] | string = [];

  private readonly _errorHandleService = inject(ErrorHandleService);
  private subscription = new Subscription();

  constructor(private readonly _filtroBuscaService: FiltroBuscaService) {}

  ngOnInit(): void {
    this.filtrarPorFasesDaObra();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['fasesSelecionadas']) {
      let selecionadas: number[] = [];
      if (Array.isArray(this.fasesSelecionadas)) {
        selecionadas = this.fasesSelecionadas.map(Number);
      } else if (
        typeof this.fasesSelecionadas === 'string' &&
        this.fasesSelecionadas
      ) {

        if (this.fasesSelecionadas.includes(',')) {
          selecionadas = this.fasesSelecionadas
            .split(',')
            .map((s) => Number(s.trim()))
            .filter((n) => !isNaN(n));
        } else {
          selecionadas = [Number(this.fasesSelecionadas)];
        }
      }
      if (this.filtroFaseDaObra.length) {
        this.filtroFaseDaObra = this.filtroFaseDaObra.map((item) => ({
          ...item,
          checked: selecionadas.includes(item.id),
        }));
      }
      this._fasesSelecionadasCache = selecionadas;
    }
  }

  private _fasesSelecionadasCache: number[] = [];

  filtrarPorFasesDaObra() {
    this.subscription.add(
      this._filtroBuscaService.buscarFiltroFaseDaObra().subscribe({
        next: (res) => {
          if (res.success) {
            let selecionadas: number[] = [];
            if (this._fasesSelecionadasCache.length) {
              selecionadas = this._fasesSelecionadasCache;
            } else if (Array.isArray(this.fasesSelecionadas)) {
              selecionadas = this.fasesSelecionadas.map(Number);
            } else if (
              typeof this.fasesSelecionadas === 'string' &&
              this.fasesSelecionadas
            ) {
              if (this.fasesSelecionadas.includes(',')) {
                selecionadas = this.fasesSelecionadas
                  .split(',')
                  .map((s) => Number(s.trim()))
                  .filter((n) => !isNaN(n));
              } else {
                selecionadas = [Number(this.fasesSelecionadas)];
              }
            }
            this.filtroFaseDaObra = res.data.map((item) => ({
              ...item,
              checked: selecionadas.includes(item.id),
            }));
 
            setTimeout(() => {
              this.sincronizarCheckboxes();
            }, 0);
          } else {
            this._errorHandleService.throwConsoleError(res.message);
          }
        },
      })
    );
  }

  private sincronizarCheckboxes() {
    let selecionadas: number[] = [];
    if (Array.isArray(this.fasesSelecionadas)) {
      selecionadas = this.fasesSelecionadas.map(Number);
    } else if (
      typeof this.fasesSelecionadas === 'string' &&
      this.fasesSelecionadas
    ) {
      if (this.fasesSelecionadas.includes(',')) {
        selecionadas = this.fasesSelecionadas
          .split(',')
          .map((s) => Number(s.trim()))
          .filter((n) => !isNaN(n));
      } else {
        selecionadas = [Number(this.fasesSelecionadas)];
      }
    }
    if (this.filtroFaseDaObra.length) {
      this.filtroFaseDaObra = this.filtroFaseDaObra.map((item) => ({
        ...item,
        checked: selecionadas.includes(item.id),
      }));
    }
  }

  onCheckChange(event: Event, option: any) {
    option.checked = (event.target as HTMLInputElement).checked;
    this.filtroFaseDaObra = [...this.filtroFaseDaObra];
    const selecionados = this.filtroFaseDaObra.filter((o) => o.checked);
    this.fasesObraChange.emit(selecionados);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
